import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

export const DAILY_MODES = {
  INTERVAL: 'interval',
  WORKDAYS: 'workdays',
};

export default function DailyPattern({
  mode = DAILY_MODES.INTERVAL,
  onModeChange,
  interval,
  onIntervalChange,
}) {
  const { t } = useTranslation('common');

  return (
    <RadioGroup
      value={mode}
      onChange={(e) => onModeChange(e.target.value)}
    >
      {/* Every X days */}
      <Box display="flex" alignItems="center">
        <FormControlLabel
          value={DAILY_MODES.INTERVAL}
          control={<Radio size="small" />}
          label={t('common:rrule.pattern.every')}
          sx={{ mr: 0 }}
        />
        <TextField
          type="number"
          value={interval}
          onChange={(e) => onIntervalChange(Math.max(1, parseInt(e.target.value) || 1))}
          slotProps={{ htmlInput: { min: 1, style: { textAlign: 'center' } } }}
          size="small"
          sx={{ width: 70, mx: 1 }}
          disabled={mode !== DAILY_MODES.INTERVAL}
        />
        <Typography color={mode !== DAILY_MODES.INTERVAL ? 'text.disabled' : 'text.primary'}>
          {t('common:rrule.pattern.every_days')}
        </Typography>
      </Box>

      {/* Every workday */}
      <FormControlLabel
        value={DAILY_MODES.WORKDAYS}
        control={<Radio size="small" />}
        label={t('common:rrule.pattern.every_workday')}
      />
    </RadioGroup>
  );
}
